import { render, staticRenderFns } from "./HuaweiMobileServiceUpdateAccountModal.vue?vue&type=template&id=5da9c68c&scoped=true"
import script from "./HuaweiMobileServiceUpdateAccountModal.vue?vue&type=script&lang=js"
export * from "./HuaweiMobileServiceUpdateAccountModal.vue?vue&type=script&lang=js"
import style0 from "./HuaweiMobileServiceUpdateAccountModal.vue?vue&type=style&index=0&id=5da9c68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9c68c",
  null
  
)

export default component.exports